/**
 *   Created by wangyuelong on 2018/7/6
 */
import _ from 'lodash';
import * as React from 'react';
import { isAndroid, isIOS } from '@tencent/qb-article-util/lib/UA';
import Tag from 'uistyles/comby/tag';
import cropImageOnlie from '../../../utility/cropImageOnlie';
import { ImageInfo } from '../../../ducks/types';
import { isHippy, postMessage } from '../../../utility';

type Props = {
  img: ImageInfo,
};

const canOpenPicView = () => {
  const ua = window.navigator.userAgent || '';
  const version = _.get(window, 'browser.env.version');
  // 安卓8.7 iOS8.8才能查看图片
  if ((isAndroid(ua) && version >= 87) || (isIOS(ua) && version >= 88)) {
    return true;
  }
  return false;
};

export default class CommentImage extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.setStyle(false);
    this.state = {};
  }

  onImageClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    if (!canOpenPicView()) return;

    const { img = {} } = this.props;
    const url = img.sPicUrl || '';
    if (!url) return;
    const images = [url];

    if (isHippy()) {
      postMessage(
        JSON.stringify({
          func: 'coolread.openPicView',
          data: { url, urls: images, index: 0, newWindow: true },
        }),
      );
    } else {
      const openPicView = _.get(window, 'browser.coolread.openPicView');
      openPicView && openPicView(url, images, 0);
    }
  };

  setStyle(showImage) {
    const { img = {} } = this.props;

    const wRate = 0.653;
    const sSize = {
      width: typeof window !== 'undefined' ? window.innerWidth * wRate : 245,
      height: typeof window !== 'undefined' ? (window.innerWidth * wRate) / 1.416 : 375,
    };

    const iSize = {
      width: sSize.width || 245,
      height: img.iWidth ? (sSize.width * img.iHeight) / img.iWidth : 375,
    };

    let style = sSize;

    if (iSize.width && iSize.height) {
      // 图片宽高都小于标准尺寸时，按图片原有大小展示
      if (iSize.width <= sSize.width && iSize.height <= sSize.height) {
        style = {
          width: iSize.width,
          height: iSize.height,
        };
      } else if (iSize.width > iSize.height && iSize.width <= sSize.width * 4) {
        style = {
          width: sSize.width,
          height: (sSize.width * iSize.height) / iSize.width,
        };
      } else if (iSize.height >= iSize.width && iSize.height <= sSize.height * 4) {
        style = {
          width: (iSize.width * sSize.height) / iSize.height,
          height: sSize.height,
        };
      } else if (iSize.width > iSize.height) {
        style = {
          ...sSize,
          tag: '横图',
        };
      } else {
        style = {
          ...sSize,
          tag: '长图',
        };
      }
    }

    let src = '';
    if (showImage) {
      src = cropImageOnlie({
        url: img.sPicUrl || '',
        width: style.width * 2,
        height: style.height * 2,
        imgflag: 31,
      });
    } else {
      style = {
        width: 0,
        height: 0,
      };
    }

    this.setState({
      imgSize: style,
      src,
      tag: style.tag || '',
    });
  }

  componentDidMount() {
    this.setStyle(true);
  }

  render() {
    const { img = {} } = this.props;
    const { src, imgSize, tag } = this.state;
    if (!imgSize) {
      return null;
    }
    const style = {
      paddingTop: '8px',
      width: `${imgSize.width}px`,
      height: `${imgSize.height}px`,
      overflow: 'hidden',
      position: 'relative',
    };

    if (!img || !img.sPicUrl) return null;

    return (
      <div style={style}>
        {src ? (
          <img alt="qige" onClick={this.onImageClick} src={src} style={{ width: style.width, height: style.height }} />
        ) : null}
        {tag ? (
          <Tag type="default" size="md" round style={{ position: 'absolute', left: '4px', top: '12px' }}>
            {tag}
          </Tag>
        ) : null}
      </div>
    );
  }
}
